import { select } from 'satcheljs/lib/legacy';
import SearchResultsType from 'owa-service/lib/contract/SearchResultsType';
import { isFeatureEnabled } from 'owa-feature-flags';

export const PAGE_CONTEXTS: PageContext[] = [
    { resultRowOffset: 0, resultRowCount: 25, pageNumber: 0 },
    { resultRowOffset: 25, resultRowCount: 50, pageNumber: 1 },
    { resultRowOffset: 75, resultRowCount: 75, pageNumber: 2 },
    { resultRowOffset: 150, resultRowCount: 100, pageNumber: 3 },
    { resultRowOffset: 250, resultRowCount: 200, pageNumber: 4 },
    { resultRowOffset: 450, resultRowCount: 200, pageNumber: 5 },
    { resultRowOffset: 650, resultRowCount: 200, pageNumber: 6 },
    { resultRowOffset: 850, resultRowCount: 200, pageNumber: 7 },
];

export interface PageContext {
    readonly resultRowOffset: number;
    readonly resultRowCount: number;
    readonly pageNumber: number;
}

export interface PageContextState {
    pageContexts: PageContext[];
}

/**
 * Gets the pageContext based on the page number
 * @param pageNumber Page for which to get the rowOffset and rowCount
 */
export let getPageContext = select<PageContextState>({
    pageContexts: () => PAGE_CONTEXTS,
})(function getPageContext(pageNumber: number, state?: PageContextState): PageContext {
    if (pageNumber < 0 || pageNumber >= state.pageContexts.length) {
        throw new Error('The pageNumber for execute search is invalid:' + pageNumber);
    }

    return state.pageContexts[pageNumber];
});

/**
 * Gets the next page context if available
 * @param currentPageContext the current page context
 * @param searchResults the search results for the current page number
 */
export let getNextPageContext = select<PageContextState>({
    pageContexts: () => PAGE_CONTEXTS,
})(function getNextPageContext(
    currentPageContext: PageContext,
    searchResults: SearchResultsType,
    state?: PageContextState
): PageContext {
    const nextPageNumber = currentPageContext.pageNumber + 1;
    const maxPages = isFeatureEnabled('sea-fetchMax') ? state.pageContexts.length : 4;
    if (searchResults.MoreResultsAvailable && nextPageNumber < maxPages) {
        return getPageContext(nextPageNumber, state);
    } else {
        return null;
    }
});
